import { render, staticRenderFns } from "./ProgressStep2.vue?vue&type=template&id=245267b2"
import script from "./ProgressStep2.vue?vue&type=script&lang=js"
export * from "./ProgressStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports